import { render, staticRenderFns } from "./TaskFocusDetailsRow.vue?vue&type=template&id=38aa4645&scoped=true&"
import script from "./TaskFocusDetailsRow.vue?vue&type=script&lang=js&"
export * from "./TaskFocusDetailsRow.vue?vue&type=script&lang=js&"
import style0 from "./TaskFocusDetailsRow.vue?vue&type=style&index=0&id=38aa4645&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa4645",
  null
  
)

export default component.exports